import { Box, Inline, Skeleton } from '@machobear/design-system'
import { vars } from '@machobear/design-system/css'

const Card = () => {
  return (
    <Box
      borderRadius="large"
      padding="medium"
      gap="xsmall"
      display="flex"
      flexDirection="column"
      justifyContent="spaceBetween"
      maxWidth="xsmall"
      width="full"
      style={{ border: `1px solid ${vars.borderColor.neutralLight}` }}
    >
      <Inline space="xsmall">
        <Box display="flex" flexDirection="row" gap="xsmall">
          <Box>
            <Skeleton.Shape width={24} height={24} borderRadius="circle" />
          </Box>
          <Box display="flex" flexDirection="column" gap="xxxsmall">
            <Skeleton.Shape width={160} height={32} />
            <Skeleton.Shape width={80} height={24} />
          </Box>
        </Box>
      </Inline>

      <Box display="flex" gap="xsmall">
        <Skeleton.Button />
        <Skeleton.Button />
      </Box>
    </Box>
  )
}

export default Card
